import { TemplateType } from 'constants/templateTypes';

export const ATTACH_TEMPLATE_TAKEOVER_ID = 'attach-template-takeover';
export const ATTACH_TEMPLATE_TAKEOVER_SEARCH_INPUT_ID = `${ATTACH_TEMPLATE_TAKEOVER_ID}--search-input`;
export const ATTACH_TEMPLATE_TAKEOVER_HEADER_ACTIONS_ID = `${ATTACH_TEMPLATE_TAKEOVER_ID}--tab-list-container`;

export const TEMPLATE_TYPE_MENU_OPTIONS = [
  {
    label: 'Business-initiated',
    id: TemplateType.BusinessInitiated,
  },
  { label: 'User-initiated', id: TemplateType.UserInitiated },
];

export const displayContent = {
  campaignLabel: 'Campaign content',
  inputPlaceholder: 'Search by template ID or name',
  takeoverTitle: 'Attach a template',
  templateLabel: 'Templates',
  title: 'Select Template',
  workflowLabel: 'Journey content',
  whatsAppBannerBlast:
    'The list of available templates is filtered to only show business-initiated templates approved by Meta.',
  whatsAppBannerApiTriggered:
    'The list of available templates is filtered to only show business-initiated templates approved by Meta and all user-initiated templates.',
};
